import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { SaveBusinessOnboardingRequest } from '$/requests/SaveBusinessOnboarding.ts';

const useSaveBusinessOnboarding = () => {
  const client = supabaseClient;

  const mutationFn = async (request: SaveBusinessOnboardingRequest) => {
    return saveBusinessOnboarding(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useSaveBusinessOnboarding;

async function saveBusinessOnboarding(
  client: SupabaseClient,
  request: SaveBusinessOnboardingRequest
): Promise<BackendSuccessResponse<{ message: string }>> {
  const { data, error } = await client.functions.invoke('save_business_onboarding', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
